import { connect } from "react-redux";
import VariablesComponent from "../../Components/Variables/VariablesComponent";
import { setVariables } from "../../Redux/Actions/VariablesWorkflowsActions";

const mapStateToProps = (state) => ({
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  VARIABLES: state.reducer.VARIABLES,
});

const mapDispatchToProps = (dispatch) => ({
  setVariables: (variables) => dispatch(setVariables(variables)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VariablesComponent);
